import { useTranslation } from 'react-i18next';
import success from 'assets/images/Positive.svg';

export const PaymentSuccessApp = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        width: '100%',
        background: '#fff',
        height: 'calc(100vh - 100px)',
        textAlign: 'center',
        padding: '3.5rem 16px 0',
        fontFamily: 'Roboto400',
      }}
    >
      <p style={{ fontSize: '26px', marginBottom: '2rem' }}>{t('app.title')}</p>
      <p style={{ fontSize: '22px', color: '#C21B17', fontFamily: 'Roboto500', marginBottom: '2rem' }}>
        {t('app.desc')}
      </p>
      <div>
        <img src={success} alt="" />
      </div>
    </div>
  );
};
